import { literals } from "@/constants/literals";
import { formatDateDDMmmYYYY } from "@/lib/dates";
import type { OrderItem } from "@/types/types.d";

const showYesNoAnswer = (value: boolean | null) =>
  value === null ? "-" : value ? literals.yes : literals.no;

const showNoMandatoryValue = (value: string | null) => value || "-";

export const getMetaDetailData = (photoData: OrderItem) => {
  return [
    {
      label: literals.date,
      value: formatDateDDMmmYYYY(photoData.createdAt),
    },
    {
      label: literals.visibleClient,
      value: showYesNoAnswer(photoData.visible),
    },
    {
      label: literals.client,
      value: showNoMandatoryValue(photoData.customer),
    },
    { label: literals.workstation, value: photoData.area },
    { label: literals.step, value: photoData.step },
    {
      label: literals.returnToOrigin,
      value: showYesNoAnswer(photoData.originReturn),
    },
  ];
};

export const getPhotoName = (imageKey: string) =>
  imageKey.split("/").slice(-1)[0];

export const getPhotoData = (photoData: OrderItem) => {
  return [
    {
      label: literals.customerOrderNoServ,
      value: showNoMandatoryValue(photoData.customerOrderNoserv),
    },
    {
      label: literals.workOrder,
      value: showNoMandatoryValue(photoData.sapWorkOrder),
    },
    {
      label: literals.docu9R1,
      value: showNoMandatoryValue(photoData.document9r1),
    },
    {
      label: literals.partIn,
      value: showNoMandatoryValue(photoData.orderIn),
    },
    {
      label: literals.serialIn,
      value: showNoMandatoryValue(photoData.serialIn),
    },
    {
      label: literals.partOut,
      value: showNoMandatoryValue(photoData.orderOut),
    },
    {
      label: literals.serialOut,
      value: showNoMandatoryValue(photoData.serialOut),
    },
    {
      label: literals.ownPackaging,
      value: showYesNoAnswer(photoData.ownPackaging),
    },
    {
      label: literals.correctPackaging,
      value: showYesNoAnswer(photoData.correctPackaging),
    },
    {
      label: literals.damagedPackaging,
      value: showYesNoAnswer(photoData.damagedPackaging),
    },
    {
      label: literals.packagingRef,
      value: showNoMandatoryValue(photoData.packagingReference),
    },
    {
      label: literals.ownPackagingOut,
      value: showYesNoAnswer(photoData.ownPackagingOut),
    },
    {
      label: literals.iberiaPackagingOut,
      value: showYesNoAnswer(photoData.iberiaPackagingOut),
    },
  ];
};
